// components/general/PlacesSelect.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useGoogleMaps } from 'config/GoogleMapsProvider'
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import CircularProgress from '@material-ui/core/CircularProgress';

// Maps script loaded globally via GoogleMapsProvider

/* ---------- component ---------- */
export default function PlacesSelect({ value, onChange, label = 'Google Place' }) {
  const { isLoaded, loadError } = useGoogleMaps()
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState('');

  useEffect(() => {
    (async () => {
      if (loadError) {
        console.error('Google Maps failed to load for PlacesSelect', loadError)
        setLoading(false)
        return
      }
      if (!isLoaded) return
      try {

        const autocomplete = new window.google.maps.places.Autocomplete(
          inputRef.current,
          { types: ['establishment'], componentRestrictions: { country: 'ie' } }
        );

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          setText(place.name || '');
          placeCache[place.place_id] = place; // cache it
          onChange(place.place_id, place);
        });

        // If value is a placeId, get its name
        if (value && !placeCache[value]) {
          const service = new window.google.maps.places.PlacesService(document.createElement('div'));
          service.getDetails({ placeId: value }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setText(place.name || '');
              placeCache[value] = place;
            }
          });
        } else if (value && placeCache[value]) {
          setText(placeCache[value].name || '');
        } else if (!value) {
          setText('');
        }

      } catch (e) {
        console.error('Failed to init Places autocomplete', e);
      } finally {
        setLoading(false);
      }
    })();
  }, [value, isLoaded, loadError]);

  // Handle manual clearing of the input
  const handleInputChange = (e) => {
    setText(e.target.value);
    if (e.target.value === '') {
      onChange('', null);
    }
  };

  if (loadError) {
    return <OutlinedInput disabled value="" placeholder="Maps failed to load" />
  }

  return (
    <OutlinedInput
      inputRef={inputRef}
      value={text}
      onChange={handleInputChange}
      placeholder="Start typing your business name…"
      disabled={loading || !isLoaded}
      endAdornment={loading && <CircularProgress size={18} />}
    />
  );
}

/* simple cache so we don’t keep hitting Places Details API (optional) */
const placeCache = {};